// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V1CB","content":"styles_content__1MgJT","tableWrap":"styles_tableWrap__26PPk"};